import styled from "styled-components";

export const TemplatesStyle = styled.div`
  padding-bottom: 50px;
  overflow-y: auto;
  height: calc(100vh - 290px);
  @media only screen and (max-width: 767px) {
    height: calc(100vh - 240px);
  }
  .field-wrap {
    display: flex;
    justify-content: space-between;
    > div {
      width: 49%;
    }
  }
  .static-field-wrap {
    display: flex;
    justify-content: space-between;
    @media only screen and (max-width: 767px) {
      flex-wrap: wrap;
      > div:nth-child(1) {
        width: 100% !important;
      }
      > div:nth-child(2) {
        width: 100% !important;
      }
    }
    > div:nth-child(1) {
      width: 68%;
    }
    .static-skills-container {
      display: flex;
      align-items: end;
      margin-right: 6px;
      .static-skill-icon-btn {
        margin-left: 4px;
        svg {
          fill: #1976d2;
        }
      }
    }
    > div:nth-child(2) {
      width: 30%;
      > div > div.labelContainer {
        white-space: nowrap;
      }
    }
    .MuiInputBase-root:not(.MuiInputBase-multiline) {
      height: auto !important;
    }
    .MuiAutocomplete-tag {
      height: 28px;
    }
  }

  .static-field-helper {
    font-size: 13px;
    margin-top: 6px;
    font-weight: 500;
    color: #757675;
  }
  .field-comment {
    .inputContainer {
      margin-top: 10px;
    }
  }
  h3 {
    margin-bottom: 0;
  }
  .custom-field-wrap-container {
    display: flex;
    justify-content: space-between;
    >div:first-child {
      width: 68%;
    }
    .custom-field-wrap {
      width: 30%;
    }
  }
  .job-question-field {
    textarea {
      height: 53px !important;
    }
  }
  .inputContainer,
  .selectContainer,
  .datePickerContainer,
  .dropzone-block,
  .radio-container {
    margin-top: 15px;
  }
  .MuiDialogActions-root {
    position: absolute;
    right: 16px;
    bottom: 8px;
  }
  @media only screen and (max-width: 767px) {
    .MuiDialogActions-root {
      position: fixed;
      right: 10px;
      bottom: 30px;
    }
  }
  .custom-btn-container {
    display: flex;
    justify-content: flex-end;
  }
  .custom-option-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 12px;
    button {
      margin: 0 0 16px 8px;
    }
    .inputContainer {
      margin-top: 0;
    }
  }
  .custom-without-option-container {
    justify-content: flex-end;
    margin-bottom: 0;
  }
  .custom-option-field {
    width: 68%;
    .helper-text {
      font-size: 13px;
      color: ${({ theme }) => theme.fieldText1};
    }
  }
  .custom-preview-container {
    h3 {
      margin: 8px 0 0;
    }
  }
  .custom-reset-form {
    margin-left: 6px;
    svg {
      width: 20px;
      height: 20px;
    }
    path {
      fill: #1976d2;
    }
  }
  .custom-template-container {
    padding: 0 8px;
  }
  .MuiDialogActions-root {
    button svg path {
      fill: #1976d2;
    }
  }
  @media only screen and (max-width: 700px) {
    .custom-field-wrap-container {
      flex-wrap: wrap;
      >div:first-child {
        width: 100%;
      }
      .custom-field-wrap {
        width: 100%;
      }
    }
  }
`;

export const DNDFormStyle = styled.div`
  background-color: ${({ theme, isdragging }) => (isdragging ? theme.mode === 'light' ? "#f0f4f8" : theme.lightGray : theme.modalBg1)};
  border-radius: 5px;
  & >div .drag-field-item:first-child >div >div {
    margin-top: 0px;
  }
  .drag-field-bg {
    background-color: ${({ theme }) => theme.lightBlue};
  }
  .drag-field-item {
    display: flex;
    align-items: flex-end;
    border-radius: 5px;
    padding: 0 6px;
    > div:first-child {
      width: 100%;
      margin-right: 8px;
    }
  }
  .dnd-edit-field, .form-drag-icon {
    svg {
      fill: ${({ theme }) => theme.svg1};
    }
  }
`;
